import { useState } from 'react';
import { brandInitials, type BusinessBrandingDTO } from '@print-saas/shared';
import { brandAsset } from '../lib/branding';

/**
 * The business's logo on a white tile (so dark and transparent logos read on the dark screen), or its initials
 * when it has no logo yet.
 */
export function BrandMark({ branding, apiUrl, className = '' }: { branding: BusinessBrandingDTO; apiUrl: string; className?: string }) {
  const src = brandAsset(apiUrl, branding.logoUrl);
  const [failed, setFailed] = useState<string | null>(null);
  if (src && failed !== src) {
    return (
      <div className={`grid shrink-0 place-items-center overflow-hidden rounded-[1.8vmin] bg-white p-[0.7vmin] shadow-lg shadow-black/30 ${className}`}>
        <img src={src} alt="" className="size-full object-contain" draggable={false} onError={() => setFailed(src)} />
      </div>
    );
  }
  return (
    <div
      className={`grid shrink-0 place-items-center rounded-[1.8vmin] bg-accent font-black tracking-tight text-accent-ink shadow-lg shadow-accent/20 ${className}`}
      aria-hidden
    >
      <span className="text-[3vmin] leading-none">{brandInitials(branding.name)}</span>
    </div>
  );
}
